import React from "react";
import { WithContext as ReactTags } from 'react-tag-input';

const TagsInput = ({ tags, setTags }) => {
    const handleAddition = (tag) => {
        if (!tags.some(existingTag => existingTag.text === tag.text)) {
            const newTag = { id: new Date().getTime().toString(), text: tag.text };
            setTags(prevTags => [...prevTags, newTag]);
        } else {
            console.log("Tag already exists:", tag);
        }
    };

    const handleDelete = (index) => {
        if (index < 0 || index >= tags.length) {
            return;
        }
        const updatedTags = tags.filter((_, i) => i !== index);
        setTags(updatedTags);
    };

    return (
        <>
            <ReactTags
                tags={tags}
                handleDelete={handleDelete}
                handleAddition={handleAddition}
                allowNew={true}
                classNames={{
                    tags: "react-tags-wrapper",
                    tagInputField: "form-control mt-2",
                }}
                placeholder="Add tags..."
            />
        </>
    );
};

export default TagsInput;